/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The props for `<EmptyState />`.
 */
export interface EmptyStateProps {
  /**
   * The caption text displayed for empty state.
   */
  caption: string;

  /**
   * The children of `<EmptyState />`.
   */
  children?: React.ReactNode;

  /**
   * Additional classes.
   */
  classes?: string;

  /**
   * Custom data-id identifier for the item.
   */
  dataId?: string;

  /**
   * Empty state display mode that removes the border.
   */
  isLite?: boolean;

  /**
   * The SVG element displayed for empty state.
   */
  svg?: JSX.Element;

  /**
   * The main text displayed for empty state.
   */
  title?: string;
}

/**
 * The default prop values for `<EmptyState />`.
 */
export const emptyStateDefaults: EmptyStateProps = {
  caption: ``,
  isLite: false,
};
